import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from '../config/config';

// Import translation files
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
import arTranslation from './locales/ar/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  },
  ar: {
    translation: arTranslation
  }
};

// Function to determine the best language based on browser settings and supported languages
const getBestMatchedLanguage = (detectedLng) => {
  // If no language is detected, use default
  if (!detectedLng) {
    return config.defaultLanguage;
  }
  
  // Check if the detected language is in our supported languages
  const supportedLanguages = config.languages.map(lang => lang.code);
  
  // If the detected language is supported, use it
  if (supportedLanguages.includes(detectedLng)) {
    return detectedLng;
  }
  
  // If the detected language is a dialect (e.g., en-US), check if the base language is supported
  const baseLang = detectedLng.split('-')[0];
  if (supportedLanguages.includes(baseLang)) {
    return baseLang;
  }
  
  // Default to French if no match is found
  return config.defaultLanguage;
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: config.defaultLanguage,
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false // React already safes from XSS
    },
    
    // Custom language detector function
    lng: getBestMatchedLanguage(navigator.language || navigator.userLanguage),
    
    react: {
      useSuspense: true,
    }
  });

// Handle RTL languages
const currentLanguage = i18n.language;
const isRtl = config.languages.find(lang => lang.code === currentLanguage)?.rtl;
if (isRtl) {
  document.documentElement.dir = 'rtl';
} else {
  document.documentElement.dir = 'ltr';
}

export default i18n;
